import type { HistoryData, Team } from '~/vendor/cxy/types';

export type { HistoryData, Team };

export type FilterTypes = 'All' | 'Home' | 'Away' | 'versus';

export enum ChartVariant {
  DEFAULT = 'default',
  COMPACT = 'compact',
}

export type BarChartProps = {
  alternativeLines?: string;
  americanFormat?: boolean;
  barRadius?: number;
  customLabels?: Record<FilterTypes, string>;
  flipBarSuccess?: boolean;
  fullTabsWidth?: boolean;
  historyData: HistoryData[];
  limit?: number;
  line?: number;
  oppositionTeam?: Team;
  trackEvent?: (event: string, data: Record<string, unknown>) => void;
  variant?: ChartVariant;
};
